import { Fragment, useRef } from "react";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import { InvoiceButtons } from "../Common/InvoiceButtons";
import InvoiceSixHeader from "./InvoiceSixHeader";
import InvoiceSixTable from "./InvoiceSixTable";
import UserDetails from "./UserDetails";
import { Breadcrumbs } from "../../../../../AbstractElements";
import { ECommerce, Invoice } from "../../../../../Constants/Constants";

const InvoiceSixContainer = () => {
  const contentRef = useRef<HTMLDivElement | null>(null);
  return (
    <Fragment>
      <Breadcrumbs mainTitle={Invoice} parent={ECommerce} />
      <Container>
        <Row>
          <Col sm="12">
            <div ref={contentRef}>
              <Card>
                <CardBody>
                  <div className="invoice">
                    <div>
                      <InvoiceSixHeader />
                      <hr />
                      <UserDetails />
                      <InvoiceSixTable />
                    </div>
                  </div>
                </CardBody>
              </Card>
            </div>
          </Col>
        </Row>
      </Container>
      <InvoiceButtons contentRef={contentRef} />
    </Fragment>
  );
};

export default InvoiceSixContainer;
